/**
 * <brand-marquee>
 *
 * The scrolling itself is pure CSS — a linear, infinite transform animation on
 * the track. This element's ONLY job is to work out how long one loop should
 * take, so the logos move at a constant pixels-per-second regardless of how
 * many logos there are or how wide the screen is.
 *
 * The track holds two identical groups. The animation moves it by -50%, i.e.
 * exactly one group's width, so the loop point is invisible.
 */
if (!customElements.get('brand-marquee')) {
  class BrandMarquee extends HTMLElement {
    #group = null;
    #observer = null;

    connectedCallback() {
      this.#group = this.querySelector('.brand-marquee__group');
      if (!this.#group) return;

      // Fires on first layout, on resize, and again as each logo image loads
      // and the group's real width changes.
      this.#observer = new ResizeObserver(() => this.#updateDuration());
      this.#observer.observe(this.#group);

      window.addEventListener('resize', this.#updateDuration);
      this.#updateDuration();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      window.removeEventListener('resize', this.#updateDuration);
    }

    #updateDuration = () => {
      if (!this.#group) return;

      const isMobile = window.innerWidth <= 700;
      const speed = Number(
        isMobile ? this.dataset.speedMobile : this.dataset.speedDesktop
      );

      // Matches the previous implementation's pixels-per-second so existing
      // speed settings keep the pace merchants already picked.
      const divisor = Math.max(65 - (Number.isFinite(speed) ? speed : 20), 1);
      const pixelsPerSecond = 960 / divisor;

      // offsetWidth includes the trailing gap, which is padding on the group —
      // that is what makes the wrap seamless.
      const distance = this.#group.offsetWidth;
      if (distance <= 0) return;

      this.style.setProperty(
        '--marquee-duration',
        `${(distance / pixelsPerSecond).toFixed(3)}s`
      );
    };
  }

  customElements.define('brand-marquee', BrandMarquee);
}